import { configureStore } from "@reduxjs/toolkit";
import chatReducer from "./slices/connectChatSlice";
import uiReducer from "./slices/connectUiSlice";
import wizReducer from "./reducers/wizModule";

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    ui: uiReducer,
    wiz: wizReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
